import { render, staticRenderFns } from "./Commentaires.vue?vue&type=template&id=4a56f484"
import script from "./Commentaires.vue?vue&type=script&lang=js"
export * from "./Commentaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports